export default class ScheduleItem {
  constructor(rawModel) {
    this.Key = rawModel?.Key
    this.ResourceKeys = rawModel?.ResourceKeys || []
    this.Weekdays = rawModel?.Weekdays || []
    this.Description = rawModel?.Description
    this.StartTime = rawModel?.StartTime
    this.EndTime = rawModel?.EndTime
    this.LimitBookableProducts = rawModel?.LimitBookableProducts || false
    this.BookingLength = rawModel?.BookingLength
    this.Capacity = rawModel?.Capacity
    this.StartDate = rawModel?.StartDate
    this.EndDate = rawModel?.EndDate
    this.Available = rawModel ? rawModel.Available : null
    this.Priority = rawModel?.Priority
    this.ClassificationConstraints = rawModel?.ClassificationConstraints || []
  }
}
